import { combineReducers } from 'redux';
import salesReducer from './salesReducer';
import tableReducer from './tableReducer';
import columnReducer from './columnReducer';
import createRuleReducer from './createRuleReducer';
import fullCompanyViewReducer from './fullCompanyViewReducer';
import itemDrillDownReducer from './itemDrillDownReducer';
import appGuideReducer from './appGuideReducer';
import anomalyDetectionReducer from './anomalyDetectionReducer';
import chartComparisonReducer from './chartComparisonReducer';
import rcaReducer from './rcaReducer';
import storeDrillDownReducer from './storeDrillDownReducer';
const rootReducer = combineReducers({
	salesReducer,
	tableReducer,
	columnReducer,
	createRuleReducer,
	fullCompanyViewReducer,
	itemDrillDownReducer,
	appGuideReducer,
	anomalyDetectionReducer,
	rcaReducer,
	chartComparisonReducer,
	storeDrillDownReducer,
});

export default rootReducer;
